module.exports = __webpack_public_path__ + "media/stylesheets/images/icons/chevron-carousel-prev-pc-ba955ebc055b9409959ed721502aad89.svg";